const menuBuilder = () =>{
    if(document.querySelector('.kirinus-wide-dropdown')){
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const allDropdowns = document.querySelectorAll('.kirinus-wide-dropdown');
        document.addEventListener('hidden.bs.collapse', ev =>{
            if(ev.target.querySelector('.kirinus-wide-dropdown')){
                allDropdowns.forEach(d => {
                    setUpHighlights(d);

                })

            }
            return;



        });
        document.addEventListener('hidden.bs.dropdown', ev =>{
            let trigger = ev.target;
            let dropdown = trigger.nextElementSibling;
            if(dropdown.classList.contains('kirinus-wide-dropdown')){
                setUpHighlights(dropdown);

            }


        });
        document.addEventListener('shown.bs.dropdown', ev =>{
            let trigger = ev.target;
            let dropdown = trigger.nextElementSibling;
            if(dropdown.classList.contains('kirinus-wide-dropdown')){
                let height = dropdown.offsetHeight;
                dropdown.style.minHeight = height+'px';
            }

        });
        allDropdowns.forEach(drop => {
            setUpHighlights(drop);
            if(vw < 991){
                drop.previousElementSibling.setAttribute('aria-expanded', 'true');
            }
            if(drop.getAttribute('data-dropdown-click') == 'false'){

                drop.addEventListener('click', ev =>{

                    if(ev.target.closest('.kirinus-wide-dropdown--back-link')){
                        ev.preventDefault();
                        let back = ev.target.closest('.kirinus-wide-dropdown--back-link');
                        let wrapper = back.parentElement;
                        if(wrapper.classList.contains('kirinus-wide-dropdown--sub-menu-holder')){
                            if(wrapper.classList.contains('kirinus-wide-dropdown--sub-menu-holder__second-level')){
                                wrapper.classList.remove('kirinus-wide-dropdown--sub-menu-holder__active');
                                drop.setAttribute('data-active-sub-field', '');

                            }else{
                                drop.setAttribute('data-active-field', '');

                            }
                            let allDropdownLinks = drop.querySelectorAll('.kirinus-wide-dropdown--link__active');
                            allDropdownLinks.forEach(l =>{
                                l.classList.remove('kirinus-wide-dropdown--link__active');
                            })
                            wrapper.classList.remove('kirinus-wide-dropdown--sub-menu-holder__active');
                        }

                        return;
                    }
                    if(!ev.target.closest('.kirinus-wide-dropdown--link')) return;
                    ev.preventDefault();
                    if(ev.target.closest('.kirinus-wide-dropdown--top-level')){

                        let linkButton = ev.target.closest('.kirinus-wide-dropdown--top-level');
                        let state = drop.getAttribute('data-dropdown-state');
                        let activeMain = drop.getAttribute('data-active-field');
                        let activeSub = drop.getAttribute('data-active-sub-field');
                        let target = linkButton.getAttribute('data-hover-color');

                        if(linkButton.getAttribute('href') !== '#' && linkButton.getAttribute('href') !== '#!') {
                            window.location.href = linkButton.href;
                            return;
                        }
                        if( (state == 'setup' || state == 'first-level-active') && activeMain !== target){

                            resetHighlights(drop);
                            let allSameLevelLinks = drop.querySelectorAll('.kirinus-wide-dropdown--link__active');
                            allSameLevelLinks.forEach(l => {
                                l.classList.remove('kirinus-wide-dropdown--link__active');
                            })
                            let allSubMenusLevelOne = document.querySelectorAll('.kirinus-wide-dropdown--sub-menu-holder');
                            if(allSubMenusLevelOne.length > 0){
                                allSubMenusLevelOne.forEach(sub =>{
                                    if(sub.getAttribute('data-sub-menu-target') !== target){
                                        sub.classList.remove('kirinus-wide-dropdown--sub-menu-holder__active');
                                    }
                                    else{
                                        sub.classList.add('kirinus-wide-dropdown--sub-menu-holder__active');
                                    }
                                })
                            }
                            let targetCard = drop.querySelector(`[data-field="${target}"]`);
                            targetCard.classList.add('kirinus-field-highlight-card__active');
                            drop.setAttribute('data-dropdown-state', 'first-level-active');
                            drop.setAttribute('data-active-field', target);
                            drop.setAttribute('data-active-sub-field', '');
                            linkButton.classList.add('kirinus-wide-dropdown--link__active');
                        }

                        if(activeMain == target){

                            setUpHighlights(drop);
                            drop.setAttribute('data-active-field', '');
                            drop.setAttribute('data-active-sub-field', '');

                        }


                    }
                    if(ev.target.closest('.kirinus-wide-dropdown--level-1')){
                        let linkButton = ev.target.closest('.kirinus-wide-dropdown--level-1');
                        let subTarget = linkButton.getAttribute('data-sub-target');
                        let targetMenu = drop.querySelector(`[data-sub-sub-menu-target="${subTarget}"]`)

                        if(subTarget == '' || subTarget == null || targetMenu == null) {

                            window.location.href = linkButton.href;
                            return;
                        }
                        if(subTarget !== drop.getAttribute('data-active-sub-field')){
                            let allSameLevelLinks = drop.querySelectorAll('.kirinus-wide-dropdown--level-1');
                            allSameLevelLinks.forEach(l => {
                                l.classList.remove('kirinus-wide-dropdown--link__active');
                            })
                            let activeCards = drop.querySelectorAll('.kirinus-field-highlight-card__active');
                            if(activeCards.length > 0){
                                activeCards.forEach(c => {
                                    c.classList.remove('kirinus-field-highlight-card__active');
                                })
                            }
                            let activeSubMenus = drop.querySelectorAll('.kirinus-wide-dropdown--sub-menu-holder__second-level.kirinus-wide-dropdown--sub-menu-holder__active');
                            if(activeSubMenus.length > 0){
                                activeSubMenus.forEach(s => {
                                    s.classList.remove('kirinus-wide-dropdown--sub-menu-holder__active');

                                })
                            }
                            linkButton.classList.add('kirinus-wide-dropdown--link__active');
                            targetMenu.classList.add('kirinus-wide-dropdown--sub-menu-holder__active');
                            //drop.setAttribute('data-dropdown-state', 'second-level-active');
                            drop.setAttribute('data-active-sub-field', subTarget);
                        }else{
                            targetMenu.classList.remove('kirinus-wide-dropdown--sub-menu-holder__active');
                            let activeCardTarget = linkButton.getAttribute('data-hover-color');
                            let cardTarget = drop.querySelector(`[data-field="${activeCardTarget}"]`)
                            linkButton.classList.remove('kirinus-wide-dropdown--link__active')
                            cardTarget.classList.add('kirinus-field-highlight-card__active');
                            drop.setAttribute('data-active-sub-field', '');
                        }



                    }
                    if(ev.target.closest('.kirinus-wide-dropdown--level-2')){
                        let linkButton = ev.target.closest('.kirinus-wide-dropdown--level-2');
                        window.location.href = linkButton.href;
                        return;
                    }
                })
                drop.setAttribute('data-dropdown-click', 'true');
            }
        })
        function setUpHighlights (dropdown) {
            let state = dropdown.getAttribute('data-dropdown-state')
            if(state == 'initial' || state == 'first-level-active'){
                let allSameLevelLinks = dropdown.querySelectorAll('.kirinus-wide-dropdown--link__active');
                if(allSameLevelLinks.length > 0){
                    allSameLevelLinks.forEach(l => {
                        l.classList.remove('kirinus-wide-dropdown--link__active');
                    })
                }

                if(state == 'first-level-active'){
                    let allCards = document.querySelectorAll('.kirinus-field-highlight-card');
                    if(allCards.length > 0){
                        allCards.forEach(card =>{
                            card.classList.remove('kirinus-field-highlight-card__active');
                        })
                    }
                }
                let highlights = dropdown.querySelectorAll('.kirinus-field-highlight-card__initial');
                let elementHolder = dropdown.querySelectorAll('.kirinus-wide-dropdown--element');
                let allSubs = dropdown.querySelectorAll('.kirinus-wide-dropdown--sub-menu-holder__active');
                if(allSubs.length > 0){
                    allSubs.forEach(s => {
                        s.classList.remove('kirinus-wide-dropdown--sub-menu-holder__active');
                    })
                }
                if(highlights.length > 0){
                    if(dropdown.getAttribute('data-cloned-state') == 'false'){
                        let toMove = highlights[0].cloneNode(true);
                        toMove.setAttribute('data-field', '');
                        elementHolder[1].insertBefore(toMove, elementHolder[1].firstChild);
                        highlights[0].classList.remove('kirinus-field-highlight-card__initial');
                        dropdown.setAttribute('data-cloned-state', 'true');
                    }
                    highlights = dropdown.querySelectorAll('.kirinus-field-highlight-card__initial');

                    highlights.forEach(high =>{
                        high.classList.add('kirinus-field-highlight-card__active');
                    })
                    dropdown.setAttribute('data-dropdown-state', 'setup');
                    dropdown.setAttribute('data-active-field', '');
                    dropdown.setAttribute('data-active-sub-field', '')

                }
            }
        }
        function resetHighlights (dropdown) {
            if(dropdown.getAttribute('data-dropdown-state') != 'initial'){

                let highlights = dropdown.querySelectorAll('.kirinus-field-highlight-card');

                if(highlights.length > 0){
                    highlights.forEach(high => {
                        high.classList.remove('kirinus-field-highlight-card__active');
                    })
                    dropdown.setAttribute('data-dropdown-state', 'initial');
                }
            }
        }
    }
}
export default menuBuilder;